var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAcSmall = function SvgAcSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "acSmall_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#acSmall_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "acSmall_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#acSmall_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "m7.666 11.1-2.283 2.25a.28.28 0 0 1-.225.1.26.26 0 0 1-.225-.117.26.26 0 0 1-.117-.225q0-.142.117-.242l2.733-2.733v-1.8h-1.8l-2.75 2.75a.28.28 0 0 1-.225.1.3.3 0 0 1-.242-.117.28.28 0 0 1-.1-.225q0-.142.1-.225L4.9 8.333H1.983a.3.3 0 0 1-.225-.092A.33.33 0 0 1 1.666 8q0-.133.092-.233.09-.1.241-.1h2.9L2.65 5.399a.28.28 0 0 1-.1-.225q0-.142.117-.241.083-.1.225-.1t.242.1l2.733 2.733h1.8v-1.8l-2.75-2.733a.28.28 0 0 1-.1-.226q0-.14.117-.241.082-.1.225-.1.142 0 .225.1l2.283 2.233V2q0-.133.091-.233a.31.31 0 0 1 .242-.1.32.32 0 0 1 .234.1.32.32 0 0 1 .1.233v2.9l2.266-2.233q.084-.1.226-.1.14 0 .241.1t.1.241q0 .142-.1.226L8.333 5.866v1.8h1.8l2.733-2.733q.083-.1.225-.1t.242.116q.1.083.1.225t-.1.225l-2.234 2.267H14a.32.32 0 0 1 .234.1.32.32 0 0 1 .1.233q0 .15-.1.242a.34.34 0 0 1-.234.092h-2.9l2.234 2.283q.1.083.1.225t-.1.225a.3.3 0 0 1-.242.117.26.26 0 0 1-.225-.117l-2.733-2.733h-1.8v1.8l2.733 2.75q.1.082.1.225a.3.3 0 0 1-.117.241.28.28 0 0 1-.224.1.28.28 0 0 1-.226-.1L8.333 11.1v2.917a.3.3 0 0 1-.1.225.34.34 0 0 1-.234.092q-.15 0-.242-.092A.33.33 0 0 1 7.666 14z"
  })))));
};
export default SvgAcSmall;